const appSettingsFunc = function () {
    return window.APP_SETTINGS;
};
export const appSettings = appSettingsFunc();
